import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

const reducer = (aggregate: any, [key, value]: any) => ({
    ...aggregate,
    [key]: helpers.getListReducer({}, value)
});

function* get() {
    try {
        const { id } = yield select((state) => state.audits.item);
        const auditRatingUrl = `${config.api.paths.auditRating}?audit_id=${id}`;
        const { data } = yield call(http.authorized.get, auditRatingUrl);
        yield put(actionCreators.itemSet(data[0]));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("On audit rating get:", { error });
        console.error(error);
        yield put(actionCreators.getFailure(error));
    }
}

function* getRatingCore() {
    try {
        const auditRatingColorRes = yield call(
            http.authorized.get,
            `${config.api.paths.auditRatingColors}`
        );
       
        const addId = (data) => data.map((item, id) => ({ id, ...item }));
        const res = {
            auditRatingColor: addId(auditRatingColorRes.data)
            
        };
        const data = Object.entries(res).reduce(reducer, {});
        yield put(actionCreators.getCoreSuccess(data));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("On audit rating Core get:", { error });
        console.error(error);
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_RATINGS_CORE_GET_REQUEST, getRatingCore),
        takeLatest(actionTypes.AUDIT_RATING_GET_REQUEST, get)
    ]);
}

 /** This is not required for now  
        // // const auditRatingCategoriesRes = yield call(
        // //     http.authorized.get,
        // // `${config.api.paths.auditRatingCategories}`
        // // );
        // // const auditOrgRatingThresholdsRes = yield call(
        // //     http.authorized.get,
        // // `${config.api.paths.auditOrgRatingThresholds}`
        // // );
        
        // /** add to res object if required for future purpose 
        // // auditRatingCategories: auditRatingCategoriesRes.data,
        //     // auditOrgRatingThreshold: auditOrgRatingThresholdsRes.data 
            */